// extracted by mini-css-extract-plugin
export default {"bar":"CategoryBar_bar__ji+J4","inner":"CategoryBar_inner__8UYsr"};